export const TOAST_GENERIC_ERROR = {
  title: 'Uh oh! Something went wrong.',
  description: 'If the problem persists please contact an admin.',
  variant: 'destructive'
};
